<template>
  <div>
    <nd-dialog v-model="visible" close-btn :footer="false">
      <div class="version-container">
        <div class="title">版本更新提示 <img src="./img_xiakuan@2x.png" ></div>
        <p>当前版本过低，升级到最新版本即可获得免审额度</p>
        <h5>您也可关注天美贷公众号</h5>
        <img src="./img_weixin@2x.png" class="wechat" @click="copy">
        <nd-button class="update" @click="downloadApp">立即更新</nd-button>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { copyToClipbord } from '@/assets/utils'

export default {
  name: 'versionTips',
  props: {
    value: {
      type: Boolean,
      default: false
  } },
  data () {
    return {}
  },
  methods: {
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style  lang="less" scoped>
@import "../../assets/less/mixin.less";

.version-container {
  background: #fff;
  padding: 50px;
  .title {
    display: flex;
    font-size: 42px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    img {
      width: 251px;
    }
  }
  .update {
    width: 380px;
    height: 80px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 40px;
    line-height: 80px;
    margin: 40px auto 0;
  }
  p {
    margin-top: 20px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  h5 {
    margin-top: 20px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 37px;
  }
  .wechat {
    margin-top: 20px;
    width: 520px;
  }
}
</style>